
<template>
  <div>
    <GChart
      type="ComboChart"
      :data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'
import { GChart } from 'vue-google-charts'

export default {
  name: 'ConsolidationsPareto',
  props: {
    total_by_cat: {
      type: Array,
    },
  },
  components: {
    GChart
  },
  data() {
    return {
      all_categories: null,
      chartData: [
        ['Categoria', 'Observado', { role: 'annotation'}, { role: 'style' }, 'Referência', { role: 'annotation'} ],
        // ['2010', 10, '10%', 'color: gray', 15, '15%'],
        // ['2020', 14, '14%', 'color: #76A7FA', 12, '12%'],
        // ['2030', 16, '16%', 'opacity: 0.2', 17, '17%'],
        // ['2040', 22, '22%', 'stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF', 27, '27%'],
        // ['2050', 28, '28%', 'stroke-color: #871B47; stroke-opacity: 0.6; stroke-width: 8; fill-color: #BC5679; fill-opacity: 0.2', 37, '37%'],
        // ['Categoria', 'Improdutivo', { role: 'annotation'}, 'Complementar', { role: 'annotation'}, 'Produtivo', { role: 'annotation'}, 'Average', { role: 'annotation'}],
        // ['1', 35, '35%', null, null, 35, '35%', 15, '15%'],
        // ['2', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['3', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['4', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['5', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['6', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['7', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['8', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['9', 40, '40%', 0, null, 60, '60%', 75, '75%'],
        // ['10', 40, '40%', 0, null, 60, '60%', 75, '75%'],
      ],
      chartOptions: {
        alwaysOutside: true,
        height: 350,
        isStacked: false,
        colors: ['#ff5252', '#1976d2', '#4caf50'],
        legend: {position: 'none'},
        seriesType: 'bars',
        series: {1: {type: 'line', curveType: 'function',}},
        vAxis: {title: '% Observado'},
        hAxis: {
          textStyle: {
            fontSize : 11
          }
        },
        animation:{
          duration: 1000,
          easing: 'out',
        },
      }
    }
  },
  methods: {
    getCategories() {
      Api.Category.index({with_deleted: 1}).then(r=>r.data).then(d=>{
        this.all_categories = [...d]
        this.prepareChart()
      })
    },
    prepareChart(){
      for (let idx = 0; idx < this.total_by_cat.length; idx++) {
        const cat = this.total_by_cat[idx];
        let a_cat = this.all_categories.find(c=>c.id == cat.id)
        let obj = {
          name: cat.name.split('COMPLEMENTAR - ').pop(),
          percent: Math.round(cat.percent),
          label: `${Math.round(cat.percent)}%`,
          color: 'color: ' + (cat.code==1? '#ff5252' : cat.code==10? '#4caf50' : cat.kind=='I'? '#E57373' : '#A5D6A7'),
          ref: Math.round(Number(a_cat.percent_ref)),
          ref_label: null, //`${Math.round(a_cat.percent_ref)}%`,
        }
        this.chartData.push(Object.values(obj))
      }
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getCategories();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>